module.exports = __webpack_public_path__ + "static/media/LongAndLat.31a07e70.png";